import { FC } from 'react';
import styled, { css } from 'styled-components';

import { focusShadow } from '#/components/common';
// reused stuff from paywall plugins, should be moved out later
import {
  cssPlanContainerBase as cssPickerItemContainerBase,
  PlanPickerGrid as PickerGrid,
  PlanPickerMainText as PickerText,
  PlanPickerSubText as PickerSubText,
} from '#/plugins/paywall/components';
import { remify } from '#/service/utils';

const cssPickerItemSelected = css`
  background-image: linear-gradient(
    to bottom,
    var(--iapGradientTop),
    var(--iapGradientBottom)
  );
  color: var(--iapForeground);
`;

const PickerItemRoot = styled.button<{ $selected: boolean }>`
  ${cssPickerItemContainerBase};
  display: grid;
  row-gap: ${remify(8)};
  min-height: ${remify(76)};
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  border: none;
  text-align: initial;
  width: 100%;

  ${({ $selected }) => $selected && cssPickerItemSelected}

  &:hover {
    ${cssPickerItemSelected}
  }

  &.focus-visible {
    ${focusShadow}
  }
`;

export interface PickerItemProps {
  id: string;
  title: string;
  subtitle?: string;
  detail?: string;
}

export interface PickerComponentProps extends PickerItemProps {
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const PickerItem: FC<PickerComponentProps> = ({
  id,
  title,
  subtitle,
  detail,
  isSelected,
  onSelect,
}) => (
  <PickerItemRoot
    $selected={isSelected}
    aria-checked={isSelected}
    onClick={() => onSelect(id)}
    role="radio"
  >
    <PickerGrid>
      <PickerText>{title}</PickerText>
      <PickerText>{detail}</PickerText>
    </PickerGrid>
    {subtitle && <PickerSubText>{subtitle}</PickerSubText>}
  </PickerItemRoot>
);

export default PickerItem;
